/* angular */
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class HistoryService {

	private tokenKey: string = 'authorizationData';
	private isLoggedIn: boolean;
	private token: string;
	private errorMessage = '[Celine] Error occurred on history api';

	//
	constructor (private httpClient: HttpClient) {
		this.isLoggedIn = sessionStorage.getItem(this.tokenKey) ? true : false;
		this.token = this.isLoggedIn ? sessionStorage.getItem(this.tokenKey) : null;
	}

	// sendHistory
	public sendHistory(routeUrl: any) {
		try {
			this.token = this.isLoggedIn ? sessionStorage.getItem(this.tokenKey) : null;
			if ((this.isLoggedIn) && (this.token) && (routeUrl) && (routeUrl.indexOf('?=') === -1) && (routeUrl.indexOf('id_token') === -1)) {
				const body = {};
				const apiUrl = `/api/experience/history/${routeUrl}`;
				const httpOptions = {
					headers: new HttpHeaders(
						{
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + this.token
						}
					)
				};

				this.httpClient.post<any>(apiUrl, body, httpOptions)
					.subscribe(
						data => { },
						error => console.warn(this.errorMessage)
					);
			}
		} catch (e) {
			console.warn(this.errorMessage);
		}
	}

}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/services/history.service.ts